/**
 * Builds a Storyblok image URL, applying the Storyblok Image Service resize
 * transform (`/m/...`) only for raster images.
 *
 * SVGs must NOT go through the Image Service: Storyblok rasterizes SVGs to a
 * bitmap at the requested pixel size when a `/m/` transform is present, which
 * is what causes SVG logos/icons to look blurry. For `.svg` filenames we
 * return the original asset URL untouched so the browser renders the vector
 * file directly.
 */
export function getStoryblokImageUrl(
  filename: string | undefined | null,
  transform?: string
): string {
  if (!filename) return "";
  if (filename.toLowerCase().endsWith(".svg")) return filename;
  return transform ? `${filename}/m/${transform}` : filename;
}
